var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15090_57796)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15090_57796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6275 18.6275 24 12 24C5.37258 24 0 18.6275 0 12C0 5.37258 5.37258 0 12 0C18.6275 0 24 5.37258 24 12Z",
    fill: "#017737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7381 10.0923C18.7381 13.4138 16.5935 15.6855 13.527 15.6855C12.0692 15.6855 10.8677 15.0852 10.418 14.335L10.4392 15.1065V19.8635H7.30884V7.56345C7.30884 7.39233 7.26627 7.34882 7.0728 7.34882H6V4.73491H8.61668C9.8172 4.73491 10.118 5.76346 10.2032 6.21394C10.6753 5.42126 11.9183 4.5 13.6769 4.5C16.7009 4.49903 18.7381 6.74852 18.7381 10.0923ZM15.543 10.1135C15.543 8.33483 14.3851 7.11392 12.9263 7.11392C11.7258 7.11392 10.3744 7.90657 10.3744 10.1358C10.3744 11.5926 11.189 13.1141 12.8837 13.1141C14.1278 13.1132 15.543 12.2132 15.543 10.1135Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15090_57796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15090_57796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedrive);
export default __webpack_public_path__ + "static/media/pipedrive.9f41db5d820acaa4f07a55069a931a54.svg";
export { ForwardRef as ReactComponent };